import { put, call, takeLatest, fork, select } from 'redux-saga/effects'

import RootState from '../root-state'
import { emergenciesActionType, emergenciesActions } from './actions'
import { auth0Actions } from '../auth0'

import { getEmergencies } from '../api'

import { EmergenciesParam } from './emergencies'

export function* fetchEmergencies(action: any) {
  try {
    yield put(auth0Actions.checkSession())
    const state: RootState = yield select()
    const token = state.auth0.auth.idToken
    const { pageSize } = state.emergencies
    const request: EmergenciesParam = action.payload || {}
    const { reported_at_from, reported_at_to } = request
    const response = yield call(getEmergencies, token, {
      count: request.count ?? pageSize,
      offset: request.offset ?? 0,
      reported_at_from,
      reported_at_to,
      station_id: request.station_id ?? undefined,
    })
    yield put(
      emergenciesActions.fetchEmergenciesSucceeded(response.emergencies, response.totalCount)
    )
  } catch (error) {
    yield put(emergenciesActions.throwError(error))
  }
}

export function* watchFetchEmergencies() {
  yield takeLatest(emergenciesActionType.FETCH_EMERGENCIES, fetchEmergencies)
}

export const emergenciesSagas = [fork(watchFetchEmergencies)]
